// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import moment from 'moment'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
// import BaiduMap from 'vue-baidu-map'
// Vue.use(ElementUI)
// Vue.use(BaiduMap,{
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'U6nWyKDQMVeNwgktgP5yFvhMkEDgBFnc'
// })
// Vue.prototype.$moment = moment;
Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   next();
// });
router.afterEach((to, from, next) => {
  window.scrollTo(0,0);
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
});
Vue.filter('fmoney', function (s) {
  //  n = n > 0 && n <= 20 ? n : 2;   
  let n = 0;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  // return t.split("").reverse().join("") + "." + r;
  return t.split("").reverse().join("");
})

Vue.filter('enter', function (value) {
  console.log(value.split("↵").join("<br>")) 
  return value.split("↵").join("<br>");
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
})


// WEBPACK FOOTER //
// ./src/main.js